import { Children, Component } from 'react';
import getPDFPageState from '../../selectors/getPDFPageState';
import { isChirpEnabled } from '../../utils/isChirpEnabled';
const KEY_CODES = {
  UP: 38,
  LEFT: 37,
  DOWN: 40,
  RIGHT: 39
};
export default class PDFKeyControls extends Component {
  constructor(...args) {
    super(...args);
    this.handleKeydown = e => {
      const {
        onPage,
        pageIndex,
        onChangePageCHIRP,
        pageNumber
      } = this.props;
      const {
        previousPageDisabled,
        nextPageDisabled
      } = getPDFPageState(this.props);
      const isUngatedToChirp = isChirpEnabled();
      switch (e.which) {
        case KEY_CODES.UP:
        case KEY_CODES.LEFT:
          if (previousPageDisabled) {
            return;
          }
          if (isUngatedToChirp) {
            onChangePageCHIRP({
              leavingPageNumber: pageNumber,
              enteringPageNumber: pageNumber - 1
            });
          } else {
            onPage(pageIndex - 1);
          }
          return;
        case KEY_CODES.DOWN:
        case KEY_CODES.RIGHT:
          if (nextPageDisabled) {
            return;
          }
          if (isUngatedToChirp) {
            onChangePageCHIRP({
              leavingPageNumber: pageNumber,
              enteringPageNumber: pageNumber + 1
            });
          } else {
            onPage(pageIndex + 1);
          }
          return;
        default:
          return;
      }
    };
  }
  componentDidMount() {
    window.addEventListener('keydown', this.handleKeydown);
  }
  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeydown);
  }
  render() {
    return Children.only(this.props.children);
  }
}